import debounce                 from '../util/debounce';
import FieldWithoutAccessoryBar from './field_without_accessory_bar';
import React                    from 'react';


// Simple search form.  F7 supports a few more things that we don't use here.
export default class SearchForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onBlur               = this.onBlur.bind(this);
    this.onSubmit             = this.onSubmit.bind(this);
    this.clearQuery           = this.clearQuery.bind(this);
    this.onCancel             = this.onCancel.bind(this);
    this.state                = {
      showCancel: false,
      query:      ''
    };
    this.onChange             = this.onChange.bind(this);
    this.setQueryWithDebounce = debounce(this.setQuery, 300);
  }

  onBlur({ target }) {
    const hasValue = target.value.length > 0;

    this.setState({ showCancel: hasValue });
  }

  onChange(event) {
    const input      = event.target;
    const hasValue   = input.value.length > 0;
    const hasFocus   = document.activeElement === input;
    const showCancel = hasValue || hasFocus;

    this.setState({ showCancel, query: input.value }, () => {
      this.setQueryWithDebounce(input.value);
    });
  }

  setQuery(value) {
    this.props.setQuery(value);
  }

  onSubmit(event) {
    event.preventDefault();
  }

  onCancel() {
    this.clearQuery();
    this.setState({ showCancel: false });
  }

  clearQuery() {
    this.setState({ query: '' });
    this.setQuery('');
  }

  render() {
    const { query }       = this.state;
    const { showCancel }  = this.state;
    const { placeholder } = this.props;
    const showXOut        = query.length > 0;

    return (
      <form onSubmit={this.onSubmit} className="searchbar searchbar-enabled" action="">
        <div className="searchbar-inner">
          <div className="searchbar-input-wrap">
            <FieldWithoutAccessoryBar onBlur={this.onBlur}>
              {({ onTouchStart, onBlur }) => (
                <input
                  onTouchStart={onTouchStart}
                  onBlur={onBlur}
                  value={query}
                  type="search"
                  onChange={this.onChange}
                  placeholder={placeholder}
                />
              )}
            </FieldWithoutAccessoryBar>
            <i className="searchbar-icon"/>
            {showXOut && <span className="input-clear-button" onClick={this.clearQuery}/>}
          </div>
          <SearchDisableButton
            onCancel={this.onCancel}
            showCancel={showCancel}
          />
        </div>
      </form>
    );
  }
}


// The search disable button is the "Cancel" you see on the right of the input
// field.  It's visible whenever there's an input in the search field (and we
// filter results).
function SearchDisableButton({ onCancel, showCancel }) {
  const display = showCancel ? 'block' : 'none';
  const style   = { display };
  return (
    <span className='searchbar-disable-button' style={style} onClick={onCancel}>
      Cancel
    </span>
  );
}

